import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

function LegacyCompanySignInRedirect() {
  const { companyId } = useParams()
  return <Navigate to={`/chat-page?companyId=${encodeURIComponent(companyId || '')}`} replace />
}

// lazy load all the views
const SignIn = React.lazy(() => import('../pages/sign-in'))
const DevLogin = React.lazy(() => import('../pages/dev-login'))
const ChatPage = React.lazy(() => import('../pages/chat-page'))
const CrmPage = React.lazy(() => import('../pages/crm'))
const SelectDepartment = React.lazy(() => import('../pages/select-department'))
const SelectCampaign = React.lazy(() => import('../pages/select-campaign'))
// declare all routes
// TODO: improve this
const authProtectedRoutes = [
  { path: '/chat-page', component: <ChatPage /> },
  { path: '/crm', component: <CrmPage /> },
  { path: '/', exact: true, component: <Navigate to="/chat-page" /> },
  { path: '/select-department', exact: true, component: <SelectDepartment /> },
  { path: '/select-campaign', exact: true, component: <SelectCampaign /> },
  { path: '*', component: <Navigate to="/chat-page" /> }
]

const publicRoutes = [
  { path: '/sign-in', exact: true, component: <SignIn /> },
  { path: '/sign-in/:companyId', exact: true, component: <LegacyCompanySignInRedirect /> },
  { path: '/dev-login', exact: true, component: <DevLogin /> }
]

export { authProtectedRoutes, publicRoutes }
